export default "__VITE_ASSET__KHPj0JOY__"